const CANONICAL_ORIGIN = "https://reviewed.co.kr"
const LOCALE_PATH = /^\/(ko|en|cn|jp)(?:\/|$)/

/** 공격자가 넣은 외부 URL/scheme을 로그인 성공 후 이동에 사용하지 않는다. */
export const normalizeSafeInternalRedirect = (value: string | null | undefined) => {
  if (!value || !value.startsWith("/") || value.startsWith("//")) return null

  try {
    const parsed = new URL(value, CANONICAL_ORIGIN)
    if (parsed.origin !== CANONICAL_ORIGIN || !LOCALE_PATH.test(parsed.pathname)) return null
    return `${parsed.pathname}${parsed.search}${parsed.hash}`
  } catch {
    return null
  }
}

export const withSafeRedirectParam = (
  pathname: string,
  redirect: string | null | undefined,
) => {
  const safeRedirect = normalizeSafeInternalRedirect(redirect)
  if (!safeRedirect) return pathname

  const params = new URLSearchParams({ redirect: safeRedirect })
  return `${pathname}?${params.toString()}`
}
